import { render, staticRenderFns } from "./CustomerSettings.vue?vue&type=template&id=07394ee0&scoped=true&"
import script from "./CustomerSettings.vue?vue&type=script&lang=js&"
export * from "./CustomerSettings.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSettings.vue?vue&type=style&index=0&id=07394ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07394ee0",
  null
  
)

export default component.exports